import { apiSlice } from "../api/apiSlice";

export const quizMarkApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizMarks: builder.query({
      query: () => "/quizMark",
    }),
    getQuizMark: builder.query({
      query: ({ video_id, student_id }) => `/quizMark?video_id=${video_id}&student_id=${student_id}`,
    }),
    createQuizMark: builder.mutation({
      query: (data) => ({
        url: "/quizMark",
        method: "POST",
        body: data,
      }),
    }),
    updateQuizMark: builder.mutation({
      query: (data) => ({
        url: `/quizMark/${data.id}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteQuizMark: builder.mutation({
      query: (quizMarkId) => ({
        url: `/quizMark/${quizMarkId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetQuizMarksQuery,
  useGetQuizMarkQuery,
  useCreateQuizMarkMutation,
  useUpdateQuizMarkMutation,
  useDeleteQuizMarkMutation,
} = quizMarkApi;
